export default "skymp5-front/7ea37419c57aa236d605baabc1e5957b.png";